export const APP_VERSION = '0.0.0';
export const COMMIT = 'cc6064250de1d4b8fc2c1a070197988fdecea90f';
